var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 20.0001C20.3486 20.0001 23.3333 17.0153 23.3333 13.3334C23.3333 9.65152 20.3486 6.66675 16.6667 6.66675C12.9848 6.66675 10 9.65152 10 13.3334C10 17.0153 12.9848 20.0001 16.6667 20.0001Z",
    fill: "url(#paint0_linear_1125_943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.783 21.7001C17.4163 21.6834 17.0497 21.6667 16.6663 21.6667C12.633 21.6667 8.86634 22.7834 5.64967 24.7001C4.18301 25.5667 3.33301 27.2001 3.33301 28.9167V33.3334H18.7663C17.4497 31.4501 16.6663 29.1501 16.6663 26.6667C16.6663 24.8834 17.083 23.2167 17.783 21.7001Z",
    fill: "url(#paint1_linear_1125_943)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5832 26.6668C34.5832 26.3002 34.5332 25.9668 34.4832 25.6168L36.3832 23.9335L34.7165 21.0502L32.2999 21.8668C31.7665 21.4168 31.1665 21.0668 30.4999 20.8168L29.9999 18.3335H26.6665L26.1665 20.8168C25.4999 21.0668 24.8999 21.4168 24.3665 21.8668L21.9499 21.0502L20.2832 23.9335L22.1832 25.6168C22.1332 25.9668 22.0832 26.3002 22.0832 26.6668C22.0832 27.0335 22.1332 27.3668 22.1832 27.7168L20.2832 29.4002L21.9499 32.2835L24.3665 31.4668C24.8999 31.9168 25.4999 32.2668 26.1665 32.5168L26.6665 35.0002H29.9999L30.4999 32.5168C31.1665 32.2668 31.7665 31.9168 32.2999 31.4668L34.7165 32.2835L36.3832 29.4002L34.4832 27.7168C34.5332 27.3668 34.5832 27.0335 34.5832 26.6668ZM28.3332 30.0002C26.4999 30.0002 24.9999 28.5002 24.9999 26.6668C24.9999 24.8335 26.4999 23.3335 28.3332 23.3335C30.1665 23.3335 31.6665 24.8335 31.6665 26.6668C31.6665 28.5002 30.1665 30.0002 28.3332 30.0002Z",
    fill: "url(#paint2_linear_1125_943)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_943",
    x1: 16.6667,
    y1: 6.66675,
    x2: 16.6667,
    y2: 20.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1125_943",
    x1: 11.0497,
    y1: 21.6667,
    x2: 11.0497,
    y2: 33.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1125_943",
    x1: 28.3332,
    y1: 18.3335,
    x2: 28.3332,
    y2: 35.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageUser);
export default __webpack_public_path__ + "static/media/manageUser.b24294bd5127574789e5b0deccaa48e6.svg";
export { ForwardRef as ReactComponent };